/**
 * Created by kb on 2017/11/17.
 */

import {Upurl} from  '@/api/httpService'
/**
 * 上传文件帮助方法
 * @type {{}}
 */

/**
 * 上传文件帮助方法
 * @param typeName 上传文件类型名称 （返回promise对象 可用于多个上传控件同时进行上传）
 * @param uploadName  上传控件ref 引用名称
 * @param $vue    vue界面this对象
 * @param isMore  是否可上传多个文件  默认：是
 * @returns {*}
 */
export  const  fileHelp= function(typeName,uploadName,$vue,isMore=true) {
  let fileHelp =  {
    $vue: $vue,//界面this对象
    _upload:null,
    faildNames: [],//上传失败的文件名称集合
    succesFiles: [],//上传成功的文件集合
    upLen: 0,//本次上传文件的数量
    fileKey: "",
    typeName:typeName,
    uploadName,
    resolve:function () {

    },
    reject:function () {

    },
    headers:{
      'x-auth-token':(sessionStorage.getItem('token') || '')
    },
    fileChange(file, fileList){
        if(!isMore) {
          if (fileList.length > 1) {
            fileList.splice(0, 1);
          }
        }
    },
    // initFile(files){
    //   let newfiles = files || [];
    //   if (newfiles.constructor !== Array) {
    //     newfiles = [];
    //   }
    //   this._upload.fileList = newfiles;
    // },
    remove(file, fileList){
      if (file.status == "success") {
        let _this = fileHelp; //当前的this 对象指向上传控件对象
        let findIndex = this.fileList.findIndex(value => {
          return value.name === file.name;
        });
        if (findIndex >= 0) {
          this.fileList.splice(findIndex, 1)
        }
      }
    },
    preview(file){
      console.log(Upurl+"/common/download?fileName="+file.url+"&realName="+file.name);
      window.open(Upurl+"/common/download?fileName="+file.url+"&realName="+file.name, "下载文件",);
      // let Wins = window.open("Upurl"+file.url, "下载文件", "width=" + window.screen.availWidth + ",height=" + (window.screen.availHeight - 33) + ",menubar=no,toolbar=no,scrollbars=yes,status=no,titlebar=no,resizable=yes,location=no");
      // Wins.moveTo(-3, 0);
    },
    //上传成功方法
    succes(response, file, fileList){
      let _this = fileHelp; //当前的this 对象指向上传控件对象
      if (response.status === "SUCCESS" && response.errorCode == null) {
        _this.succesFiles.push({attachName: file.name, pathName: response.result});
      } else {
        _this.faildNames.push(file.name);
      }
      //如果文件全部上传完成则触发回调方法
      let readyFiles = this.uploadFiles.filter(value => {
        return value.status !== "success";
      });
      if (readyFiles.length == 0) {
        let initFiles = [];
        if(isMore) {
          initFiles = this.fileList.constructor === Array ? this.fileList.map((item) => {
            return {attachName: (item.attachName || item.name), pathName: (item.pathName || item.url)}
          }) : [];
        }else{
          initFiles = []
        }
        let newFiles = initFiles.concat(_this.succesFiles);
        if (_this.faildNames.length == 0) {
          _this.resolve(newFiles);
        } else {
          _this.$vue.$confirm(_this.typeName + '上传失败：' + _this.faildNames.length + '个，是否继续提交？', '提示', {type: "warning"})
            .then(() => {
              _this.resolve(newFiles);
            }).catch(() => {
            _this.reject(new Error(_this.typeName + "上传失败"));
          });
        }
      }
    },
    //上传失败方法
    faild(err, file, fileList) {
      let _this = fileHelp;
      _this.faildNames.push(file.name);
      //如果文件全部上传完成则触发回调方法
      let readyFiles = this.uploadFiles.filter(value => {
        return value.status == "ready";
      });
      if (readyFiles.length == 0) {
        if (_this.faildNames.length == _this.upLen) {
          _this.reject(new Error(_this.typeName + "上传失败"));
        } else {
          let initFiles = this.fileList.constructor === Array ? this.fileList.map((item) => {
            return {attachName: (item.attachName || item.name ), pathName: (item.pathName || item.url)}
          }) : [];
          let newFiles = initFiles.concat(_this.succesFiles);
          _this.$vue.$confirm('附件上传失败：' + _this.faildNames.length + '个，是否继续提交？', '提示', {type: "warning"})
            .then(() => {
              _this.resolve(newFiles);
            }).catch(() => {
            _this.reject(new Error(this.typeName + "上传失败"));
          });
        }
      }
    },
    submit(){
      let _this=this;
      return new Promise((resolve, reject)=> {
        _this.resolve = resolve;
        _this.reject = reject;
        _this.faildNames = [];
        _this.upLen == 0;
        try {
          if (_this.$vue == null) {
            console.error('请赋值界面this对象');
            _this.reject(new Error(_this.typeName + "上传失败"));
          }
          else if (_this._upload == null || _this._upload == undefined) {
            console.error('请初始化上传控件对象')
            _this.reject(new Error(_this.typeName + "上传失败"));
          }
          else {
            //判断当前上传控件是否有成功的数据 如果没有则初始化上传成功文件列表
            // if (this._upload.uploadFiles.length == 0) {
            //   //判断上传控件是否更换
            //   if (this._this.$refs.upload.$vnode.key != this.fileKey) {
            //     this.succesFiles = [];
            //     this.fileKey = this._this.$refs.upload.$vnode.key;
            //   }
            // }
            //判断当前上传控件是否有等待上传的文件 如果没有则直接回调callback方法
            let readyFiles = _this._upload.uploadFiles.filter(value => {
              return value.status == "ready";
            });
            if (readyFiles.length == 0) {
              let initFiles = _this._upload.fileList.constructor === Array ? _this._upload.fileList.map((item) => {
                return {attachName: (item.attachName || item.name ), pathName: (item.pathName || item.url)}
              }) : [];
              initFiles = initFiles.concat(_this.succesFiles);
              _this.resolve(initFiles);
            } else {
              _this.upLen = readyFiles.length;
              _this._upload.submit();//开始上传文件
            }
          }
        } catch (e) {
          _this.reject(new Error(_this.typeName + "上传失败"));
        }
      })
    }
  }

  //延迟加载避免控件尚未初始化
  setTimeout(function () {
    //初始化绑定上传控件与帮助类
    fileHelp.$vue.$nextTick(function () {
      fileHelp._upload = fileHelp.$vue.$refs[fileHelp.uploadName].constructor ===Array ?fileHelp.$vue.$refs[fileHelp.uploadName][0] : fileHelp.$vue.$refs[fileHelp.uploadName];
    });
  },20)


  return fileHelp;
}



/**
 * 上传文件帮助方法
 * @type {{}}
 */
export  function upFileHelp() {
  return {
    _this: null,//界面this对象
    _upload:null,//界面上传控件对象
    headers:{
      'x-auth-token':(sessionStorage.getItem('token') || '')
    },
    succesBack: function () {

    },
    fileChange(file, fileList){
      let _this = this.fileHelp || this; //当前的this 对象指向上传控件对象
      if (fileList.length > 1) {
        fileList.splice(0,1);
      }
    },
    setUpload(upload){
      this._upload=upload;
      this._this=upload.$el.__vue__;
      upload.fileHelp=this;
    },
    //上传成功方法
    succes(response, file, fileList){
      _this.succesBack(response)
    },
    //上传失败方法
    faild(err, file, fileList){
      let _this=this.fileHelp || this;
      _this._this.$message({message: "文件上传失败", type: elNotice.msgType.错误, showClose: true, duration: elNotice.duration})
    },
    submit(){
      this.faildNames = [];
      this.upLen == 0;
      try {
        if (this._this == null) {
          console.error('请赋值界面_this对象')
        }
        else if (this._upload == null || this._upload == undefined) {
          console.error('请赋值界面_this对象')
        }
        else {
          //判断当前上传控件是否有成功的数据 如果没有则初始化上传成功文件列表
          // if (this._upload.uploadFiles.length == 0) {
          //   //判断上传控件是否更换
          //   if (this._this.$refs.upload.$vnode.key != this.fileKey) {
          //     this.succesFiles = [];
          //     this.fileKey = this._this.$refs.upload.$vnode.key;
          //   }
          // }
          //判断当前上传控件是否有等待上传的文件 如果没有则直接回调callback方法
          let readyFiles = this._upload.uploadFiles.filter(value => {
            return value.status == "ready";
          });
          if (readyFiles.length == 0) {
            this._this.$message({message: "请选择要上传的文件", type: elNotice.msgType.错误, showClose: true, duration: elNotice.duration})
          } else {
            this._upload.submit();//开始上传文件
          }
        }
      } catch (e) {
        console.error('文件上传失败')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/commonJs/objExtend/uploadHelp.js